/* global rp$, window */
import './hero.scss';
import debounce from 'lodash/debounce';

var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Hero Module
	 * -----------------------------------------
	 * @section hero_js
	 ********************************************/
	(function HeroModule() {
		$onReady({
			rp$, window,
			label: 'hero',
			fn: function () {
				
				const $heroModules = rp$('.hero-module');
				rp$.each($heroModules, function HeroIterator(idx, heroModuleEle) {
					const $heroModuleEle = rp$(heroModuleEle);

					const $contentSlider = $heroModuleEle.find('.hero-content');
					const contentConfigBase64 = $contentSlider.attr('data-slider-config');
					const contentConfigDecoded = atob(contentConfigBase64);
					
					const $imageSlider = $heroModuleEle.find('.hero-images');
					const imageConfigBase64 = $imageSlider.attr('data-slider-config');
					const imageConfigDecoded = atob(imageConfigBase64);
					
					// Set Content Config
					let contentConfig = {
						items: 1,
						autoplay: true,
						autoplayTimeout: 5000,
						animateIn: 'fadeIn',
						slideBy: 1,
						dots: true,
						nav: true,
						loop: true,
						navText: [
							'<i class="fa fa-angle-left" aria-hidden="true"></i>',
							'<i class="fa fa-angle-right" aria-hidden="true"></i>'
						]
					};
					if(contentConfigDecoded !== '') {
						try {
							const contentConfigJson = JSON.parse(contentConfigDecoded);
							contentConfig = contentConfigJson;
						} catch(e) {
							console.log('Error in content JSON', e);
						}
					}			
					
					// Set Image Config
					let imageConfig = {
						items: 1,
						dots: false,
						slideBy: 1,
						animateOut: 'fadeOut',
						autoplay: true,
						autoplayTimeout: 5000,
					};
					if(imageConfigDecoded !== '') {
						try {
							const imageConfigJson = JSON.parse(imageConfigDecoded);
							imageConfig = imageConfigJson;
						} catch(e) {
							console.log('Error in image JSON', e);
						}				
					}

					let syncedSecondary = true;

					// Initialize Sliders
					window.onload = () => {
						
						$contentSlider.addClass('owl-carousel')
							.owlCarousel(contentConfig).on('changed.owl.carousel', updateImageSlider);
							
						$imageSlider.addClass('owl-carousel')
							.on('initialized.owl.carousel', function() {
								rp$($imageSlider).find('.owl-item').eq(0).addClass('current');
							})
							.owlCarousel(imageConfig).on('changed.owl.carousel', updateContentSlider);
					};
					
					function updateImageSlider(el) {
						//if you set loop to false, you have to restore this next line
						//var current = el.item.index;
				
						//if you disable loop you have to comment this block
						const count = el.item.count - 1;
						let current = Math.round(el.item.index - (el.item.count / 2) - .5);
				
						if (current < 0) {
							current = count;
						}
						if (current > count) {
							current = 0;
						}
						//end block
				
						$imageSlider
							.find('.owl-item')
							.removeClass('current')
							.eq(current)
							.addClass('current');
						
						const activeSlide = $imageSlider.find('.owl-item.active');
						const onscreen = activeSlide.length - 1;
						const start = activeSlide.first().index();
						const end = activeSlide.last().index();
				
						if (current > end) {
							$imageSlider.data('owl.carousel').to(current, 100, true);
						}
						if (current < start) {
							$imageSlider.data('owl.carousel').to(current - onscreen, 100, true);
						}
					}
				
					function updateContentSlider(el) {
						if (syncedSecondary) {
							var number = el.item.index;
							$contentSlider.data('owl.carousel').to(number, 100, true);
						}
					}
	
					function updateContentHeight() {
						const slideContent = $contentSlider.find('.slide-content');
						const sliderHeight = slideContent.outerHeight(true);
						const slideContentArr = $contentSlider.find('.slide-content-wrap');
						const slideImageArr = $imageSlider.find('.slide-image-wrap');
						const allSlidersArr = [...slideContentArr, ...slideImageArr];
	
						rp$.each(allSlidersArr, function(idx, slide_content_ele) {
							rp$(slide_content_ele).innerHeight(sliderHeight).addClass('height-adjusted');
						});
					}
					updateContentHeight();
	
					window.onresize = debounce(updateContentHeight, 250);
				});
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
